module.exports = __webpack_public_path__ + "static/media/captain.46aa32aa.svg";